import { useCallback } from "react";
import { DEFAULT_APP_TITLE } from "../../config";
import { useResetFaviconAndTitleCallback } from "./useResetFaviconAndTitleCallback";

export const PROVIDER_NO_SHOW_TITLE = `👋 Provider not here? - ${DEFAULT_APP_TITLE}`;

export function useClearProviderNoShowTabTitleCallback() {
  const resetFaviconAndTitle = useResetFaviconAndTitleCallback();

  return useCallback(
    function clearProviderNoShowTabTitle() {
      if (document.title !== PROVIDER_NO_SHOW_TITLE) {
        return;
      }

      resetFaviconAndTitle();
    },
    [resetFaviconAndTitle],
  );
}
